import { Issue } from '@property/shared';
import { AlertCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

const SEVERITY_TAGS: Record<string, string> = {
  high: 'border-ring/60 text-ring',
  medium: 'border-amber-600/50 text-amber-700',
  low: 'border-sidebar-primary/40 text-sidebar-primary',
};

interface IssuesListProps {
  issues: Issue[];
}

export function IssuesList({ issues }: IssuesListProps) {
  if (issues.length === 0) return null;
  return (
    <div className="space-y-4">
      <h2 className="px-1 font-display text-xl font-medium tracking-tight text-foreground">
        Infrastructure Issues
      </h2>
      <div className="divide-y divide-dashed divide-line border-y border-dashed border-border-strong">
        {issues.map((issue, idx) => (
          <div key={idx} className="flex items-center justify-between gap-6 py-5">
            <div className="flex items-start gap-4">
              <div className="mt-1 rounded-sm border-2 border-ring/40 p-2 text-ring">
                <AlertCircle className="size-4" />
              </div>
              <div className="space-y-1">
                <p className="text-base font-semibold tracking-tight text-foreground">
                  {issue.title}
                </p>
                <p className="text-sm leading-relaxed text-foreground/60">{issue.remarks}</p>
              </div>
            </div>
            <span
              className={cn(
                'shrink-0 rounded-sm border-2 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-[0.16em]',
                SEVERITY_TAGS[issue.severity] ?? 'border-foreground/30 text-foreground/60',
              )}
            >
              {issue.severity} priority
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
